import { IonContent, IonInput, IonPage, IonText, IonCol, IonButton, IonIcon ,IonSpinner} from "@ionic/react"
import moment from "moment"
import { useEffect, useState, useMemo } from "react"
import { Modal } from "react-bootstrap"
import { useHistory } from "react-router"
import DataTable from "react-data-table-component"
import service from "../../Service/service"
import Select from "react-select"
import Head from "../Header"
import Sidebar from "../Sidebar"
import swal from 'sweetalert';
import { searchOutline, chevronDownOutline } from "ionicons/icons";

const EmployeeExit: React.FC = () => {
    const history = useHistory();
    const [createdBy] = useState(localStorage.getItem("SignupEmpId"));

    // --------------  Employee's --------------

    const [empname, setempname] = useState('');
    const [Employecode, setEmployecode] = useState("")
    const [employeename, setemployeename] = useState('')
    const [business, setbusiness] = useState('');
    const [department, setDepartment] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [reportingManager, setreportingManager] = useState('');
    const [dateOfLeaving, setdateOfLeaving] = useState('');
    const [dateOfResignation, setdateOfResignation] = useState('')
    const [reason, setreason] = useState('');
    const [loading,setloading]=useState(false)

    // --------------Show hide input --------------

    const [showEmployeeDetails, setShowEmployeeDetails] = useState(false);

    // --------------Redirect to login --------------
    useEffect(() => {
        if (createdBy === null) {
            history.push("/login");
        } else {
        }
    }, [createdBy, history]);
    /*****************Employee Code *****************/

    // const EmployeCodes = (e:any) =>{
    //     console.log('Employee Code')
    // setEmployecode(e.target.value)
    // }

    const Employeexit = () => {
        setloading(true)
        if (!Employecode) {
            swal("", "Please enter employee code before search", "info");
            return;
        } else {
            // Clear the fields first
            setErrorMessage('');
            setempname('');
            setbusiness('');
            setDepartment('');
            setreportingManager('');
            setemployeename('');
            setShowEmployeeDetails(false);

            service.EmployeeExit(Employecode)
                .then((response) => {
                    console.log(response);
                    if (response.data.Status === '400') {
                        swal("", response.data.Message, "error");
                    } else {
                        if (response.data.Status === "200") {
                            const errorMessage = `${response.data.Errors.join('\n')}`;
                            setErrorMessage(errorMessage);
                            if (errorMessage === '') {
                                setempname(response.data.Data.name);
                                setbusiness(response.data.Data.businessUnit.businessUnitName);
                                setDepartment(response.data.Data.masterDepartment.departmentName);
                                setreportingManager(response.data.Data.reportingManager);
                                setemployeename(response.data.Data.name);
                                setShowEmployeeDetails(true);
                            } else {
                                swal({
                                    title: '',
                                    text: errorMessage,
                                    icon: 'error',
                                });
                            }
                        }
                    }
                })
                .catch((error) => {
                    alert(error);
                })
                .finally(() => {
                   
                    setTimeout(() => {
                        setloading(false); 
                    }, 500); 
                });
        }
    };


    // --------------Employee Exit Save--------------

    const ResignEmployee = () => {
        if (!dateOfResignation) {
            swal("", "Select Resignation Date", "info");
            return;
        }
        if (!dateOfLeaving) {
            swal("", "Select Relieving Date", "info");
            return;
        }
        if (!reason) {
            swal("", "Please Enter The Reason", "info");
            return;
        }

        // Use SweetAlert for confirmation
        swal({
            title: "Are you sure you want to remove this Employee",
            // text: "This action cannot be undone.",
            icon: "warning",
            buttons: ["No", "Yes"],
        }).then((confirmResignation) => {
            if (confirmResignation) {
                const reportingManagerString = reportingManager.toString();
                service
                    .EmployeeResign(
                        Employecode,
                        employeename,
                        business,
                        department,
                        reportingManagerString,
                        dateOfLeaving,
                        dateOfResignation,
                        reason,
                        createdBy
                    )
                    .then((response) => {
                        console.log(response, "iorh");
                        if (response.status === 200) {
                            swal({
                                title: "",
                                text: response.data,
                                icon: "success",
                            }).then(() => {
                                window.location.reload();
                            });
                        } else {
                            swal("", "Error occurred while saving the timesheet", "error");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        swal("", "Error occurred while saving the timesheet", "error");
                    });
            }
        });
    };
    const back = () => {
        history.goBack();
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Employee Exit </h3>
                                </div>
                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Employee Code<span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput placeholder="Type Employee Code" value={Employecode} onIonChange={(e: any) => setEmployecode(e.target.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                </div>
                                {loading && (
                                        <div
                                            style={{
                                                position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                            }}
                                        >
                                            <div >
                                                <IonSpinner style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    color: "#ff8a53"
                                                }} name="lines" />
                                            </div>
                                        </div>
                                    )}
                                <div className=" col-md-3 " style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                    <button onClick={Employeexit} className="btn btn-orange btn-block w-100">
                                        Search
                                    </button>
                                </div>
                            </div>
                            {/* --------------Employee Details listing--------------*/}
                            {showEmployeeDetails && (
                                <div>
                                    <div className="row filter-row">
                                        <div className=" col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> Employee Name <span className="text-danger">*</span></label>
                                                <div>
                                                    <IonInput value={employeename} readonly className="form-control datetimepicker" />
                                                </div>
                                            </div>

                                        </div>
                                        <div className=" col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> Bussiness Unit <span className="text-danger">*</span></label>
                                                <div>
                                                    <IonInput value={business} readonly onIonChange={(e: any) => setbusiness(e.target.value)} className="form-control datetimepicker" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> Department Unit  <span className="text-danger">*</span></label>
                                                <div>
                                                    <IonInput value={department} readonly onIonChange={(e: any) => setDepartment(e.target.value)} className="form-control datetimepicker" />
                                                </div>
                                            </div>

                                        </div>
                                        <div className=" col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Reporting person <span className="text-danger">*</span></label>
                                                <div>
                                                    <IonInput value={reportingManager} readonly onIonChange={(e: any) => setreportingManager(e.target.value)} className="form-control datetimepicker" />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="row filter-row">
                                        <div className=" col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> Date of resign <span className="text-danger">*</span></label>
                                                <div>
                                                    <IonInput value={dateOfResignation} onIonChange={(e: any) => setdateOfResignation(e.target.value)} type="date" className="form-control datetimepicker" />
                                                </div>
                                            </div>

                                        </div>
                                        <div className=" col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> Relieve Date <span className="text-danger">*</span></label>
                                                <div>
                                                    <IonInput type="date" value={dateOfLeaving} onIonChange={(e: any) => setdateOfLeaving(e.target.value)} className="form-control datetimepicker" />
                                                </div>
                                            </div>

                                        </div>
                                        <div className=" col-md-6">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> Reason <span className="text-danger">*</span></label>
                                                <div>
                                                    <textarea value={reason} onChange={(e: any) => setreason(e.target.value)} className="form-control datetimepicker" />
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                    <div className="row filter-row" style={{ marginTop: "3%" }}>

                                        <div className="col-md-3 " style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                            <button onClick={ResignEmployee} className="btn btn-orange btn-block w-100">
                                                Remove Employee from Rolls
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default EmployeeExit;